<template>
    <div class="catalogo-header">
        <nav class="white" style="height: auto; overflow: hidden;">
          <div class="nav-wrapper">
            <div class="row pt-1 ma-0">
                <!-- Logo -->
                <div class="col s12 m3 right-align pr-0">
                <a href="#" class="col s12 pa-0">
                    <img class="logomarca" :src="logo" alt="logomarca" />
                </a>
                </div>

                <!-- Barra de busca -->
                <div class="col s12 m6 pl-0">
                <div class="center">
                    <form class="col s12 pl-0" @submit.prevent="buscar">
                    <div class="row ma-0">
                        <div class="input-field col s12 grey lighten-3" style="border-radius: 8px;">
                        <i class="material-icons prefix grey-text" style="top: -6px; left: 1rem;">search</i>
                        <input
                            style="width: calc(100% - 16rem);"
                            name="search"
                            id="search"
                            type="text"
                            class="ma-0 pa-1 pl-4 left grey-text"
                            maxlength="180"
                            v-model="searchLocal"
                            placeholder="Pesquise o produto aqui..."
                            @keypress.enter.prevent="buscar"
                        />
                        <a
                            href="#"
                            class="btn-flat grey-text"
                            v-if="searchLocal"
                            @click.prevent="buscar"
                            style="position: absolute; right: 3.5rem; top: 8px; padding-left: 0.8rem; padding-right: 0.8rem; margin-right: 0.8rem; text-transform: initial; border-radius: 6px;"
                        >
                            Buscar (Enter)
                        </a>
                        <a
                            href="#"
                            class="btn-flat btn-floating"
                            v-if="searchLocal"
                            @click.prevent="limparBusca"
                            style="position: absolute; right: 0.5rem; line-height: 2; margin-right: 0.5rem; top: 6px;"
                        >
                            <i class="material-icons left grey-text" style="top: -12px; position: relative;">close</i>
                        </a>
                        </div>
                    </div>
                    </form>
                </div>
                <div class="row ma-0 catalogo-filtros-avancados">
                    <div class="input-field col s12 m4 l2">
                        <input id="catalogo-marca" type="text" v-model="advancedFiltersLocal.marca" @keypress.enter.prevent="buscar">
                        <label for="catalogo-marca" :class="{active: advancedFiltersLocal.marca}">Marca</label>
                    </div>
                    <div class="input-field col s12 m4 l2">
                        <input id="catalogo-montadora" type="text" v-model="advancedFiltersLocal.montadora" @keypress.enter.prevent="buscar">
                        <label for="catalogo-montadora" :class="{active: advancedFiltersLocal.montadora}">Montadora</label>
                    </div>
                    <div class="input-field col s12 m4 l2">
                        <input id="catalogo-grupo" type="text" v-model="advancedFiltersLocal.grupo" @keypress.enter.prevent="buscar">
                        <label for="catalogo-grupo" :class="{active: advancedFiltersLocal.grupo}">Grupo</label>
                    </div>
                    <div class="input-field col s12 m6 l2">
                        <input id="catalogo-descricao" type="text" v-model="advancedFiltersLocal.descricao" @keypress.enter.prevent="buscar">
                        <label for="catalogo-descricao" :class="{active: advancedFiltersLocal.descricao}">Descri&ccedil;&atilde;o</label>
                    </div>
                    <div class="input-field col s12 m6 l2">
                        <input id="catalogo-aplicacao" type="text" v-model="advancedFiltersLocal.aplicacao" @keypress.enter.prevent="buscar">
                        <label for="catalogo-aplicacao" :class="{active: advancedFiltersLocal.aplicacao}">Aplica&ccedil;&atilde;o</label>
                    </div>
                    <div class="col s12 l2 catalogo-filtros-acoes">
                        <a href="#" class="btn-flat grey-text" @click.prevent="buscar">
                            <i class="material-icons left">search</i>Buscar
                        </a>
                        <a href="#" class="btn-flat grey-text" @click.prevent="limparBusca">
                            <i class="material-icons left">close</i>Limpar
                        </a>
                    </div>
                </div>
                </div>

                <!-- Botões de login/cadastro -->
                <div class="col s12 m3 primary">
                <ul id="nav-mobile" class="nav-mobile">
                    <li>
                    <a class="black-text" style="height: 51.6px; line-height: 50px; border-radius: 8px;" href="#" @click.prevent="$emit('goToLogin')">Entre</a>
                    </li>
                    <li>
                    <a class="black-text" style="height: 51.6px; line-height: 50px; border-radius: 8px;" href="#" @click.prevent="$emit('goToSignin')">Cadastre-se</a>
                    </li>
                </ul>
                </div>

                <div class="divider hide-on-med-and-up col s12 pa-0 mb-1"></div>

                <FiltroHorizontal
                  :filters="filters"
                  :filtroMenuHorizontal="filtroMenuHorizontal"
                  @selecionarFiltro="selecionarFiltro"
                />
            </div>
          </div>
        </nav>
    </div>
</template>

<script>

import FiltroHorizontal from './FiltroHorizontal.vue';

export default {
  name: 'catalogo-header',
  components: {
    FiltroHorizontal,
  },
  props: {
    logo: { type: String, default: null },
    search: { type: String, default: '' },
    advancedFilters: {
      type: Object,
      default: () => ({ marca: '', montadora: '', grupo: '', descricao: '', aplicacao: '' })
    },
    filters: { type: Array, default: () => [] },
    filtroMenuHorizontal: { type: String, default: '' }
  },
  data() {
    return {
      searchLocal: this.search,
      advancedFiltersLocal: Object.assign({}, this.advancedFilters)
    };
  },
  watch: {
    search(newVal) {
      this.searchLocal = newVal;
    },
    advancedFilters: {
      handler(newVal) {
        this.advancedFiltersLocal = Object.assign({}, newVal);
      },
      deep: true
    }
  },
  methods: {
    buscar() {
      this.$emit('buscar', this.searchLocal, Object.assign({}, this.advancedFiltersLocal));
    },
    limparBusca() {
      this.searchLocal = '';
      this.advancedFiltersLocal = { marca: '', montadora: '', grupo: '', descricao: '', aplicacao: '' };
      this.$emit('limparBusca', this.searchLocal, Object.assign({}, this.advancedFiltersLocal));
    },
    selecionarFiltro(sub) {
      this.$emit('selecionarFiltro', sub);
    },
  }
};
</script>

<style lang="scss" scoped>

.logomarca {
  height: 51.6px;
  filter: drop-shadow(0px 0px 3px black);
}

.nav-wrapper {
  position: static !important;
}

.catalogo-filtros-avancados {
  clear: both;
  padding-left: 0.75rem;

  .input-field {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

  input {
    height: 2.4rem;
    margin-bottom: 0;
  }

  .catalogo-filtros-acoes {
    display: flex;
    gap: 0.25rem;
    min-height: 48px;
    align-items: center;
  }

  .catalogo-filtros-acoes .btn-flat {
    padding: 0 0.5rem;
    text-transform: none;
  }
}

.dropdown-content {
  width: 100% !important;
  left: 0 !important;
  height: 40vh !important;
  position: fixed !important;

  &.active {
    position: fixed !important;
  }
}

.dropdown-content.active {
  position: fixed !important;
}

@media only screen and (max-width: 600px) {
  .nav-wrapper {
    .right-align {
      padding: 0 !important;
      text-align: center !important;
      margin-bottom: 1rem;
    }

    .input-field {
      margin-left: 10px;
    }

    .row > .primary{
      height: 80px;
    }

    #nav-mobile {
      position: relative;
      left: 30%;

      li {
        margin-right: 1rem;

        a {
          background-color: #eee !important;
          margin-top: 1rem !important;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// CatalogoHeader.vue?c982e380